import React from "react";
import { Box, Paper, Stack } from "@mui/material";
import Chip from "@mui/material/Chip"; // Ensure you have Material-UI or adjust as necessary
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import { removeDetectKeywordFromVisuals } from "../../helpers/index.js";

const TopTrackersCard = ({ data }) => {
    return (
        <Paper
            sx={{ display: "flex", flexDirection: "column", width: { xs: '100%', sm: '50%' }, borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
            <CardHeaderTitle
                title="Top Insights"
                tooltip="Insights that came up most frequently."
            />
            <Box marginTop={2}>
                <Stack direction="row" flexWrap="wrap" gap={1}>
                    {data.slice(0, 8).map((tracker, index) => <Chip label={removeDetectKeywordFromVisuals(tracker)} key={index} size="small"/>)}
                </Stack>
            </Box>
        </Paper>
    );
};

export default TopTrackersCard;